/**
 * DK Product Master Logic (GemPage/Webvista Optimized)
 */
window.DKProduct = (function() {
  
  function init(config) {
    const { 
      sectionId, 
      variantData, 
      translations,
      selectors = {} 
    } = config;

    // --- 1. Swiper 初始化 (保持不变) ---
    const swiperTumb = new Swiper(".dktumb", {
        slidesPerView: 'auto',
        spaceBetween: 10,
        freeMode: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
        centeredSlides: true,
        centeredSlidesBounds: true
    });

    const swiperMain = new Swiper(".dkproductclearimg", {
        spaceBetween: 5,
        navigation: { nextEl: ".dkproductnext", prevEl: ".dkproductprev" },
        thumbs: { swiper: swiperTumb },
    });

    const swiperPopup = new Swiper(".dk-popup-swiper", {
        lazy: { loadPrevNext: true, loadOnTransitionStart: true },
        spaceBetween: 0,
        navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
        pagination: { el: ".swiper-pagination", type: "fraction" },
    });

    // --- 2. 内部工具函数 ---
    const formatUSD = (amount) => '$' + (amount / 100).toFixed(2);
    const qtyInput = document.querySelector('.dk-qty-input');
    const totalDisplay = document.querySelector('.dkallprice');

    function getActiveVariant() {
        const selectedOptions = Array.from(document.querySelectorAll('.variant-input:checked')).map(el => el.value);
        if (selectedOptions.length > 0) {
            return variantData.find(v => v.options.every(opt => selectedOptions.includes(opt)));
        }
        return variantData[0];
    }

    function updateStockStatus() {
        const variantWrappers = document.querySelectorAll('.dkvariant-wrapper');
        if (variantWrappers.length === 0) return;
        const selectedOptions = Array.from(document.querySelectorAll('.variant-input:checked')).map(el => el.value);

        variantWrappers.forEach((wrapper, optionIndex) => {
            wrapper.querySelectorAll('.variant-input').forEach(input => {
                let tempOptions = [...selectedOptions];
                tempOptions[optionIndex] = input.value;
                const match = variantData.find(v => v.options.every((opt, i) => tempOptions[i] === opt));
                const label = wrapper.querySelector(`label[for="${input.id}"]`);
                if (label) {
                    if (match && match.available) {
                        label.classList.remove('dkoutofstock');
                        input.disabled = false;
                    } else {
                        label.classList.add('dkoutofstock');
                        input.disabled = true;
                    }
                }
            });
        });
    }

    function updateAllDisplays() {
        const matchedVariant = getActiveVariant();
        updateStockStatus();

        if (matchedVariant) {
            const quantity = parseInt(qtyInput?.value) || 1;
            const totalPrice = Math.round(matchedVariant.price * quantity); // 确保是整数

            // 更新图片
            if (matchedVariant.featured_media) {
                swiperMain.slideTo(matchedVariant.featured_media.position - 1);
            }

            // 更新价格显示
            const priceIns = document.querySelector('[data-product-price]');
            const priceDel = document.querySelector('[data-compare-price]');
            if (priceIns) priceIns.innerHTML = formatUSD(matchedVariant.price);
            if (priceDel) {
                if (matchedVariant.compare_at_price > matchedVariant.price) {
                    priceDel.innerHTML = formatUSD(matchedVariant.compare_at_price);
                    priceDel.style.display = 'inline-block';
                } else {
                    priceDel.style.display = 'none';
                }
            }

            if (totalDisplay) totalDisplay.textContent = formatUSD(totalPrice);

            // --- 关键：Klarna 刷新逻辑 ---
            // 每次更新时重新抓取元素，防止异步加载导致的节点引用丢失
            const klarnaEl = document.getElementById('my-credit-promotion') || document.querySelector('klarna-placement');
            
            if (klarnaEl) {
                klarnaEl.setAttribute('data-purchase-amount', totalPrice.toString());
                
                // 触发 Klarna 官方库刷新
                if (window.Klarna && window.Klarna.OnsiteService) {
                    window.Klarna.OnsiteService.push({ eventName: 'refresh-placements' });
                }
            }
        }
    }

    // --- 3. 购物车刷新逻辑 (保持不变) ---
    function triggerCartUpdate() {
        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) return;

        function getSectionsToRender() {
            const sections = [{ id: 'Cart-Icon-Bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }];
            const drawerSection = cartDrawer.dataset.section || 'cart-drawer';
            if(cartDrawer && !cartDrawer.hasAttribute('data-status-silence')) {
                sections.push({ id: 'Cart-Drawer', section: drawerSection, selector: '#Cart-Drawer-Details' });
            }
            return sections;
        }

        if (typeof webvista !== 'undefined') {
            const config = webvista.fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type']; 
            const formData = new FormData();
            formData.append('sections', getSectionsToRender().map((s)=>s.section).join());
            formData.append('sections_url', window.location.pathname);
            config.body = formData;

            fetch(`${window['routes']?.cart_update_url || '/cart/update.js'}`, config)
            .then(r => r.json())
            .then(response => {
                if (response.status) return;
                if (typeof SectionDynamicUpdate !== 'undefined') {
                    SectionDynamicUpdate.updateSections(getSectionsToRender(), response['sections']);
                }
                if (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
                    webvista.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cartData: response });
                }
                if (typeof cartDrawer.show === 'function') { cartDrawer.show(); } else { cartDrawer.setAttribute('open', ''); }
            });
        }
    }

    // --- 4. 绑定事件 ---
    document.querySelectorAll('.variant-input').forEach(input => {
        input.addEventListener('change', () => {
            const wrapper = input.closest('.dkvariant-wrapper');
            const index = wrapper?.getAttribute('data-option-index');
            const display = document.getElementById(`option-value-${index}`);
            if (display) display.textContent = input.value;
            updateAllDisplays();
        });
    });

    if (qtyInput) {
        const qtyWrapper = document.querySelector('.dk-qty-selector');
        if (qtyWrapper) {
            qtyWrapper.querySelector('.plus').onclick = () => { qtyInput.value = parseInt(qtyInput.value) + 1; updateAllDisplays(); };
            qtyWrapper.querySelector('.minus').onclick = () => { if (qtyInput.value > 1) { qtyInput.value = parseInt(qtyInput.value) - 1; updateAllDisplays(); } };
        }
    }

    const addBtn = document.querySelector('.dkpaddtocart');
    if (addBtn) {
        addBtn.onclick = function() {
            const variant = getActiveVariant();
            const btnText = this.querySelector('.btn-text');
            const icon = this.querySelector('.loading-icon');
            if (!variant) return;
            this.disabled = true;
            const oldText = btnText.textContent;
            btnText.textContent = translations.adding;
            this.classList.add('dkaddingstate');
            icon.classList.add('sniper');

            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: variant.id, quantity: parseInt(qtyInput.value) || 1 })
            })
            .then(res => res.ok ? res.json() : Promise.reject())
            .then(() => {
                triggerCartUpdate();
                setTimeout(() => {
                    btnText.textContent = translations.added;
                    setTimeout(() => { btnText.textContent = oldText; this.disabled = false; }, 1500);
                    this.classList.remove('dkaddingstate');
                    icon.classList.remove('sniper');
                }, 100);
            });
        };
    }

    const shopNowBtn = document.querySelector('.dkpshopnow');
    if (shopNowBtn) {
        shopNowBtn.onclick = () => {
            const v = getActiveVariant();
            if (v) window.location.href = `/cart/${v.id}:${qtyInput.value || 1}`;
        };
    }

    const mainSlides = document.querySelectorAll('.dkproductclearimg .swiper-slide');
    const popupOverlay = document.getElementById('dk-pswp');
    mainSlides.forEach((slide, index) => {
        slide.addEventListener('click', () => {
            popupOverlay.style.display = 'flex';
            const targetImg = popupOverlay.querySelectorAll('img')[index];
            if(targetImg && targetImg.dataset.src) {
                targetImg.src = targetImg.dataset.src;
                targetImg.removeAttribute('data-src');
            }
            swiperPopup.update();
            swiperPopup.slideTo(index, 0);
            document.body.style.overflow = 'hidden';
        });
    });
    
    document.querySelector('.dk-close-popup')?.addEventListener('click', () => {
        popupOverlay.style.display = 'none';
        document.body.style.overflow = 'auto';
    });

    updateAllDisplays();
  }

  return { init: init };
})();